// Elevator Machine Calculator - v3.0
// Step 1 = Machine Configuration, Step 2 = Job & Contact Info
document.addEventListener('DOMContentLoaded', function () {

// ─── PRICING DATA ─────────────────────────────────────────────────────────
const PRICING = {
    machines: {
      'MR21-NAC': {
        name: 'Geared with Secondary Disk Brake MR21NAC',
        hands: ['Left', 'Right'],
        capacities: [1800, 2000, 2500, { value: 'Above 2500', label: 'Capacity above 2500 lbs' }],
        speeds: [100, 150, 200, { value: 'Above 200', label: 'Speed above 200 fpm' }],
        voltages: ['208', '480'],
        cost: 17500,
        sellPrice: 22220.38,
        weight: 2577,
        sku: 'MEP-MC-MR21-NAC'
      },
      'MR21-NA': {
        name: 'Geared Prepared for Rope Gripper MR21NA',
        hands: ['Left', 'Right'],
        capacities: [1800, 2000, 2500, { value: 'Above 2500', label: 'Capacity above 2500 lbs' }],
        speeds: [100, 150, 200, { value: 'Above 200', label: 'Speed above 200 fpm' }],
        voltages: ['208', '480'],
        cost: 12200,
        sellPrice: 16503.38,
        weight: 2427,
        sku: 'MEP-MC-MR21-NA'
      },
      'SG75-NAC': {
        name: 'Gearless SG75NAC',
        hands: ['Universal'],
        capacities: [1800, 2000, 2500, { value: 'Above 2500', label: 'Capacity above 2500 lbs' }],
        speeds: [100, 150, 200, { value: 'Above 200', label: 'Speed above 200 fpm' }],
        voltages: ['208', '480'],
        cost: 17500,
        sellPrice: 22777.88,
        weight: 2643,
        sku: 'MEP-MC-SG75-NAC'
      },
      'SG75NYC-HA': {
        name: 'Gearless SG75NYC-HA (NYCHA)',
        hands: ['Universal'],
        capacities: [{ value: 'Up to 2000', label: 'Up to 2000 lbs' }, { value: 'Above 2500', label: 'Capacity above 2500 lbs' }],
        speeds: [{ value: 'Up to 350', label: 'Up to 350 fpm' }, { value: 'Above 200', label: 'Speed above 200 fpm' }],
        voltages: ['208', '480'],
        cost: 23800,
        sellPrice: 28035.38,
        weight: 2643,
        sku: 'MEP-MC-SG75NYC-HA'
      }
    },
    bedplate: { name: 'Machine Bedplate', cost: 1970, sellPrice: 2470.00, sku: 'MEP-MC-BEDPLATE' },
    addons: {
      deflectorSheave: { name: 'Deflector Sheave Assembly', cost: 870, sellPrice: 1500.00, sku: 'MEP-MC-DEFLECTOR' },
      upstand: { name: 'Machine Upstand with Deflector Sheave', cost: 3470, sellPrice: 4500.00, sku: 'MEP-MC-UPSTAND' }
    }
  };

const US_STATES = ['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

// ─── STATE ────────────────────────────────────────────────────────────────
let currentStep = 1;
const formData = {
    jobName: '', jobNumber: '', city: '', state: 'NY',
    contactName: '', company: '', email: '', phone: '',
    machines: [{ type: '', hand: '', capacity: '', speed: '', voltage: '', deflectorSheave: false, upstand: false }]
  };

// ─── ROOT ─────────────────────────────────────────────────────────────────
const root = document.getElementById('machine-calculator-root');
if (!root) return;

root.style.cssText = 'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;max-width:900px;margin:0 auto;';

function render() {
    root.innerHTML = '';
    root.appendChild(renderShell());
  }

// ─── SHARED STYLES ────────────────────────────────────────────────────────
const inputStyle = 'width:100%;padding:12px 16px;border:1.5px solid #e0e0e0;border-radius:10px;font-size:15px;box-sizing:border-box;background:#fff;color:#212529;outline:none;appearance:none;-webkit-appearance:none;';
const labelStyle = 'display:block;font-weight:700;margin-bottom:6px;font-size:14px;color:#1a1a1a;';
const sectionHdrStyle = 'font-size:17px;font-weight:700;color:#1a1a1a;margin:0 0 16px;';

function fieldGroup(labelText, inputEl, mb) {
    const wrap = document.createElement('div');
    wrap.style.marginBottom = mb || '18px';
    const lbl = document.createElement('label');
    lbl.style.cssText = labelStyle;
    lbl.textContent = labelText;
    wrap.appendChild(lbl);
    wrap.appendChild(inputEl);
    return wrap;
  }

function makeInput(type, placeholder, value, onchange) {
    const el = document.createElement('input');
    el.type = type; el.placeholder = placeholder; el.value = value || '';
    el.style.cssText = inputStyle;
    el.addEventListener('input', e => onchange(e.target.value));
    return el;
  }

function makeSelect(options, value, onchange, placeholder) {
    const wrap = document.createElement('div');
    wrap.style.cssText = 'position:relative;';
    const el = document.createElement('select');
    el.style.cssText = inputStyle + 'padding-right:36px;cursor:pointer;';
    const def = document.createElement('option');
    def.value = ''; def.textContent = placeholder || 'Select...';
    el.appendChild(def);
    options.forEach(o => {
      const opt = document.createElement('option');
      opt.value = typeof o === 'object' ? o.value : o;
      opt.textContent = typeof o === 'object' ? o.label : o;
      if (String(opt.value) === String(value)) opt.selected = true;
      el.appendChild(opt);
    });
    el.addEventListener('change', e => onchange(e.target.value));
    const arrow = document.createElement('div');
    arrow.style.cssText = 'position:absolute;right:14px;top:50%;transform:translateY(-50%);pointer-events:none;color:#6c757d;font-size:12px;';
    arrow.innerHTML = '&#9660;';
    wrap.appendChild(el);
    wrap.appendChild(arrow);
    return wrap;
  }

function grid2(a, b) {
    const g = document.createElement('div');
    g.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:16px;';
    g.appendChild(a); g.appendChild(b);
    return g;
  }

// ─── SHELL WITH TAB HEADER ────────────────────────────────────────────────
function renderShell() {
    const shell = document.createElement('div');
    shell.style.cssText = 'background:#fff;border-radius:16px;box-shadow:0 4px 24px rgba(0,0,0,.08);overflow:hidden;';

    // Tab header — Step 1 = MACHINES, Step 2 = INFO
    const tabBar = document.createElement('div');
    tabBar.style.cssText = 'display:flex;border-bottom:2px solid #f0f0f0;';
    [['1', 'MACHINES'], ['2', 'INFO']].forEach(([num, label], i) => {
      const step = i + 1;
      const active = currentStep === step;
      const done = currentStep > step;
      const tab = document.createElement('div');
      tab.style.cssText = `flex:1;padding:18px 20px;display:flex;align-items:center;gap:10px;cursor:default;border-bottom:3px solid ${active ? '#0072BB' : 'transparent'};margin-bottom:-2px;`;
      const circle = document.createElement('div');
      circle.style.cssText = `width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;flex-shrink:0;background:${active ? '#0072BB' : done ? '#28a745' : '#dee2e6'};color:${active || done ? '#fff' : '#6c757d'};`;
      circle.textContent = done ? '✓' : num;
      const lbl = document.createElement('span');
      lbl.style.cssText = `font-weight:${active ? '700' : '500'};font-size:14px;color:${active ? '#0072BB' : '#6c757d'};`;
      lbl.textContent = label;
      tab.appendChild(circle); tab.appendChild(lbl);
      tabBar.appendChild(tab);
    });
    shell.appendChild(tabBar);

    const body = document.createElement('div');
    body.style.cssText = 'padding:32px;';
    body.appendChild(currentStep === 1 ? renderStep1() : renderStep2());
    shell.appendChild(body);
    return shell;
  }

// ─── STEP 1: MACHINE CONFIGURATION ────────────────────────────────────────
function renderStep1() {
    const card = document.createElement('div');

    const h2 = document.createElement('h2');
    h2.style.cssText = 'font-size:22px;font-weight:700;margin:0 0 6px;color:#212529;';
    h2.textContent = 'Machine Configuration';
    card.appendChild(h2);

    const sub = document.createElement('p');
    sub.style.cssText = 'color:#6c757d;font-size:14px;margin:0 0 24px;';
    sub.textContent = 'Configure up to 8 elevator machines.';
    card.appendChild(sub);

    formData.machines.forEach((m, idx) => {
      card.appendChild(renderMachineRow(m, idx));
    });

    if (formData.machines.length < 8) {
      // Prominent "add another machine" panel: users were missing the old dashed link-style button
      const addPanel = document.createElement('div');
      addPanel.style.cssText = 'background:#eaf4fb;border:2px dashed #0072BB;border-radius:12px;padding:20px 16px;margin-bottom:24px;text-align:center;';

      const addTitle = document.createElement('div');
      addTitle.style.cssText = 'font-size:17px;font-weight:700;color:#1a1a1a;margin-bottom:4px;';
      addTitle.textContent = formData.machines.length === 1 ? 'Need more than one machine?' : 'Quoting another machine?';
      addPanel.appendChild(addTitle);

      const addSub = document.createElement('div');
      addSub.style.cssText = 'font-size:14px;color:#555;margin-bottom:14px;';
      addSub.textContent = formData.machines.length === 1
        ? 'Add every machine for this job to the same quote (up to 8).'
        : formData.machines.length + ' machines on this quote. You can add up to 8.';
      addPanel.appendChild(addSub);

      const addBtn = document.createElement('button');
      addBtn.type = 'button';
      const addBtnBase = 'border:2px solid #0072BB;border-radius:10px;padding:14px 28px;font-size:16px;font-weight:700;cursor:pointer;width:100%;max-width:360px;transition:background .15s,color .15s;';
      const addBtnIdle = addBtnBase + 'background:#fff;color:#0072BB;';
      const addBtnHover = addBtnBase + 'background:#0072BB;color:#fff;';
      addBtn.style.cssText = addBtnIdle;
      addBtn.innerHTML = '<span style="font-size:20px;line-height:1;vertical-align:-2px;margin-right:8px;">+</span>Add Another Machine';
      addBtn.addEventListener('mouseenter', () => { addBtn.style.cssText = addBtnHover; });
      addBtn.addEventListener('mouseleave', () => { addBtn.style.cssText = addBtnIdle; });
      addBtn.addEventListener('focus', () => { addBtn.style.cssText = addBtnHover + 'outline:3px solid #99c9ea;outline-offset:2px;'; });
      addBtn.addEventListener('blur', () => { addBtn.style.cssText = addBtnIdle; });
      addBtn.addEventListener('click', () => {
        formData.machines.push({ type: '', hand: '', capacity: '', speed: '', voltage: '', deflectorSheave: false, upstand: false });
        render();
      });
      addPanel.appendChild(addBtn);
      card.appendChild(addPanel);
    }

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.style.cssText = 'background:#0072BB;color:#fff;border:none;padding:16px 32px;border-radius:10px;font-size:16px;font-weight:700;cursor:pointer;width:100%;';
    nextBtn.textContent = 'Next: Job & Contact Info →';
    nextBtn.addEventListener('click', () => {
      for (let i = 0; i < formData.machines.length; i++) {
        const m = formData.machines[i];
        const mData = PRICING.machines[m.type];
        const label = formData.machines.length > 1 ? ' (Machine ' + (i + 1) + ')' : '';
        if (!m.type) { alert('Please select a Machine Type' + label + '.'); return; }
        if (mData && mData.hands.length > 1 && !m.hand) { alert('Please select a Hand' + label + '.'); return; }
        if (!m.capacity) { alert('Please select a Capacity' + label + '.'); return; }
        if (!m.speed) { alert('Please select a Speed' + label + '.'); return; }
        if (!m.voltage) { alert('Please select a Voltage' + label + '.'); return; }
      }
      currentStep = 2;
      render();
      window.scrollTo(0, 0);
    });
    card.appendChild(nextBtn);
    return card;
  }

function renderMachineRow(m, idx) {
    const mData = m.type ? PRICING.machines[m.type] : null;
    const isComplete = m.type && m.capacity && m.speed && m.voltage && (mData && mData.hands.length === 1 ? true : m.hand);

    const row = document.createElement('div');
    row.style.cssText = 'background:#f8f9fa;border:2px solid ' + (isComplete ? '#66bb6a' : '#e9ecef') + ';border-radius:12px;padding:20px;margin-bottom:16px;';

    const rowHdr = document.createElement('div');
    rowHdr.style.cssText = 'display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;';
    const rowTitle = document.createElement('p');
    rowTitle.style.cssText = 'font-weight:700;font-size:16px;color:#212529;margin:0;';
    rowTitle.textContent = formData.machines.length > 1 ? 'Machine ' + (idx + 1) + (isComplete ? ' ✓' : '') : 'Machine Configuration' + (isComplete ? ' ✓' : '');
    rowHdr.appendChild(rowTitle);

    if (formData.machines.length > 1) {
      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.style.cssText = 'background:#dc3545;color:#fff;border:none;border-radius:8px;padding:6px 14px;font-size:13px;font-weight:600;cursor:pointer;';
      removeBtn.textContent = '✕ Remove';
      removeBtn.addEventListener('click', () => { formData.machines.splice(idx, 1); render(); });
      rowHdr.appendChild(removeBtn);
    }
    row.appendChild(rowHdr);

    row.appendChild(fieldGroup('Machine Type *',
      makeSelect(
        Object.entries(PRICING.machines).map(function(e) { return { value: e[0], label: e[1].name }; }),
        m.type,
        function(v) { formData.machines[idx].type = v; formData.machines[idx].hand = ''; formData.machines[idx].capacity = ''; formData.machines[idx].speed = ''; formData.machines[idx].upstand = (v === 'SG75NYC-HA'); render(); },
        'Select machine type...'
      )
    ));

    if (mData) {
      var handField;
      if (mData.hands.length > 1) {
        handField = fieldGroup('Hand *', makeSelect(mData.hands, m.hand, function(v) { formData.machines[idx].hand = v; render(); }, 'Select hand...'));
      } else {
        handField = document.createElement('div');
        handField.style.marginBottom = '18px';
        var hLbl = document.createElement('label'); hLbl.style.cssText = labelStyle; hLbl.textContent = 'Hand';
        var hVal = document.createElement('div');
        hVal.style.cssText = inputStyle + 'background:#f0f0f0;color:#6c757d;display:flex;align-items:center;';
        hVal.textContent = mData.hands[0];
        if (!m.hand) { formData.machines[idx].hand = mData.hands[0]; }
        handField.appendChild(hLbl); handField.appendChild(hVal);
      }

      var capField = fieldGroup('Capacity *', makeSelect(
        mData.capacities.map(function(c) { return typeof c === 'object' ? c : { value: String(c), label: String(c) + (typeof c === 'number' ? ' lbs' : '') }; }),
        String(m.capacity),
        function(v) { formData.machines[idx].capacity = v; render(); },
        'Select capacity...'
      ));
      row.appendChild(grid2(handField, capField));

      var speedField = fieldGroup('Speed *', makeSelect(
        mData.speeds.map(function(s) { return typeof s === 'object' ? s : { value: String(s), label: String(s) + (typeof s === 'number' ? ' fpm' : '') }; }),
        String(m.speed),
        function(v) { formData.machines[idx].speed = v; render(); },
        'Select speed...'
      ));
      var voltField = fieldGroup('Voltage *', makeSelect(
        mData.voltages.map(function(v) { return { value: v, label: v + 'V' }; }),
        m.voltage,
        function(v) { formData.machines[idx].voltage = v; render(); },
        'Select voltage...'
      ));
      row.appendChild(grid2(speedField, voltField));

      var isNYCHA = (m.type === 'SG75NYC-HA');

      var included = document.createElement('div');
      included.style.cssText = 'background:#e3f2fd;border:1.5px solid #0072BB;border-radius:10px;padding:14px 16px;margin-bottom:16px;font-size:14px;color:#1565c0;';
      if (isNYCHA) {
        included.innerHTML = '<strong>Included:</strong> Machine Bedplate &bull; Machine Upstand with Deflector Sheave (both automatically included)';
      } else {
        included.innerHTML = '<strong>Included:</strong> Machine Bedplate (automatically included with every machine)';
      }
      row.appendChild(included);

      var addonsBox = document.createElement('div');
      addonsBox.style.cssText = 'background:#fff;border:1.5px solid #e0e0e0;border-radius:10px;padding:14px 16px;';
      var addonsHdr = document.createElement('p');
      addonsHdr.style.cssText = 'font-weight:700;font-size:14px;color:#1a1a1a;margin:0 0 12px;';

      if (isNYCHA) {
        addonsHdr.textContent = 'Optional Add-Ons';
        addonsBox.appendChild(addonsHdr);
        var lbl = document.createElement('label');
        lbl.style.cssText = 'display:flex;align-items:center;gap:10px;cursor:pointer;margin-bottom:8px;font-size:14px;';
        var cb = document.createElement('input');
        cb.type = 'checkbox'; cb.checked = m.deflectorSheave;
        cb.style.cssText = 'width:17px;height:17px;cursor:pointer;accent-color:#0072BB;';
        cb.addEventListener('change', function() { formData.machines[idx].deflectorSheave = cb.checked; render(); });
        lbl.appendChild(cb); lbl.appendChild(document.createTextNode('Deflector Sheave Assembly'));
        addonsBox.appendChild(lbl);
      } else {
        addonsHdr.textContent = 'Optional Add-Ons';
        addonsBox.appendChild(addonsHdr);
        [['deflectorSheave', 'Deflector Sheave Assembly'], ['upstand', 'Machine Upstand with Deflector Sheave']].forEach(function(pair) {
          var key = pair[0], label = pair[1];
          var lbl = document.createElement('label');
          lbl.style.cssText = 'display:flex;align-items:center;gap:10px;cursor:pointer;margin-bottom:8px;font-size:14px;';
          var cb = document.createElement('input');
          cb.type = 'checkbox'; cb.checked = m[key];
          cb.style.cssText = 'width:17px;height:17px;cursor:pointer;accent-color:#0072BB;';
          (function(k) { cb.addEventListener('change', function() { formData.machines[idx][k] = cb.checked; render(); }); })(key);
          lbl.appendChild(cb); lbl.appendChild(document.createTextNode(label));
          addonsBox.appendChild(lbl);
        });
      }
      row.appendChild(addonsBox);
    }

    return row;
  }

// ─── STEP 2: JOB & CONTACT INFO ───────────────────────────────────────────
function renderStep2() {
    const card = document.createElement('div');

    const h2 = document.createElement('h2');
    h2.style.cssText = 'font-size:22px;font-weight:700;margin:0 0 24px;color:#212529;';
    h2.textContent = 'Job & Contact Information';
    card.appendChild(h2);

    const jobHdr = document.createElement('p');
    jobHdr.style.cssText = sectionHdrStyle;
    jobHdr.textContent = 'Job Details';
    card.appendChild(jobHdr);

    card.appendChild(grid2(
      fieldGroup('Job Name *', makeInput('text', 'Enter job name', formData.jobName, function(v) { formData.jobName = v; })),
      fieldGroup('Job Number', makeInput('text', 'Enter job number', formData.jobNumber, function(v) { formData.jobNumber = v; }))
    ));
    card.appendChild(grid2(
      fieldGroup('City *', makeInput('text', 'Enter city', formData.city, function(v) { formData.city = v; })),
      fieldGroup('State *', makeSelect(US_STATES, formData.state, function(v) { formData.state = v; }, 'Select state...'))
    ));

    const sep = document.createElement('hr');
    sep.style.cssText = 'border:none;border-top:1.5px solid #f0f0f0;margin:8px 0 24px;';
    card.appendChild(sep);

    const contactHdr = document.createElement('p');
    contactHdr.style.cssText = sectionHdrStyle;
    contactHdr.textContent = 'Contact Information';
    card.appendChild(contactHdr);

    card.appendChild(grid2(
      fieldGroup('Your Name *', makeInput('text', 'Enter your name', formData.contactName, function(v) { formData.contactName = v; })),
      fieldGroup('Company Name *', makeInput('text', 'Enter company name', formData.company, function(v) { formData.company = v; }))
    ));
    card.appendChild(grid2(
      fieldGroup('Email Address *', makeInput('email', 'Enter email address', formData.email, function(v) { formData.email = v; })),
      fieldGroup('Phone Number *', makeInput('tel', 'Enter phone number', formData.phone, function(v) { formData.phone = v; }))
    ));

    const sep2 = document.createElement('hr');
    sep2.style.cssText = 'border:none;border-top:1.5px solid #f0f0f0;margin:8px 0 24px;';
    card.appendChild(sep2);

    const sumTitle = document.createElement('p');
    sumTitle.style.cssText = sectionHdrStyle;
    sumTitle.textContent = 'Order Summary (' + formData.machines.length + ' Machine' + (formData.machines.length !== 1 ? 's' : '') + ')';
    card.appendChild(sumTitle);

    formData.machines.forEach(function(m, idx) {
      var mData = PRICING.machines[m.type];
      var sumBox = document.createElement('div');
      sumBox.style.cssText = 'background:#f8f9fa;border:1.5px solid #e9ecef;border-radius:10px;padding:14px 16px;margin-bottom:12px;font-size:14px;';
      var label = formData.machines.length > 1 ? 'Machine ' + (idx + 1) + ': ' : '';
      var isNYCHASummary = (m.type === 'SG75NYC-HA');
      var addOnsList = [];
      if (m.deflectorSheave) addOnsList.push('Deflector Sheave Assembly');
      if (!isNYCHASummary && m.upstand) addOnsList.push('Machine Upstand with Deflector Sheave');
      var capLabel = !isNaN(Number(m.capacity)) ? m.capacity + ' lbs' : m.capacity;
      var spdLabel = !isNaN(Number(m.speed)) ? m.speed + ' fpm' : m.speed;
      var includedLine = isNYCHASummary
        ? 'Machine Bedplate + Machine Upstand with Deflector Sheave'
        : 'Machine Bedplate';
      sumBox.innerHTML = '<strong>' + label + (mData ? mData.name : m.type) + '</strong><br>' +
        '<span style="color:#555;">' + m.hand + ' Hand &bull; ' + capLabel + ' &bull; ' + spdLabel + ' &bull; ' + m.voltage + 'V</span><br>' +
        '<span style="color:#888;font-size:13px;">Includes: ' + includedLine + (addOnsList.length ? ' + ' + addOnsList.join(' + ') : '') + '</span>';
      card.appendChild(sumBox);
    });

    var note = document.createElement('div');
    var isCustomQuote = formData.machines.some(function(m) { return m.capacity === 'Above 2500' || m.speed === 'Above 200'; });
    note.style.cssText = 'background:#e8f4fd;border:1.5px solid #90caf9;border-radius:10px;padding:14px 16px;font-size:14px;color:#1565c0;margin-bottom:24px;';
    note.textContent = isCustomQuote
      ? 'One or more machines require a custom quote. Submit your request and our team will follow up shortly with pricing.'
      : 'Your detailed estimate will be emailed to you after submission.';
    card.appendChild(note);

    var btnRow = document.createElement('div');
    btnRow.style.cssText = 'display:flex;gap:12px;';

    var backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.style.cssText = 'background:#6c757d;color:#fff;border:none;padding:16px 24px;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;';
    backBtn.textContent = '← Back';
    backBtn.addEventListener('click', function() { currentStep = 1; render(); window.scrollTo(0, 0); });

    var submitBtn = document.createElement('button');
    submitBtn.type = 'button';
    submitBtn.style.cssText = 'background:#0072BB;color:#fff;border:none;padding:16px 32px;border-radius:10px;font-size:16px;font-weight:700;cursor:pointer;flex:1;';
    submitBtn.textContent = 'Submit & Get My Estimate';
    submitBtn.addEventListener('click', function() { handleSubmit(submitBtn); });

    btnRow.appendChild(backBtn);
    btnRow.appendChild(submitBtn);
    card.appendChild(btnRow);

    return card;
  }

// ─── SUBMIT ───────────────────────────────────────────────────────────────
async function handleSubmit(btn) {
    if (!formData.jobName.trim()) { alert('Please enter a Job Name.'); return; }
    if (!formData.city.trim()) { alert('Please enter a City.'); return; }
    if (!formData.contactName.trim()) { alert('Please enter your Name.'); return; }
    if (!formData.company.trim()) { alert('Please enter a Company Name.'); return; }
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) { alert('Please enter a valid Email.'); return; }
    if (!formData.phone.trim()) { alert('Please enter a Phone Number.'); return; }

    btn.disabled = true;
    btn.textContent = 'Submitting...';

    try {
      const resp = await fetch('https://elevator-backend-sigma.vercel.app/api/submit-machine-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (resp.ok) {
        var isCustomQuote = formData.machines.some(function(m) { return m.capacity === 'Above 2500' || m.speed === 'Above 200'; });
        root.innerHTML = '<div style="background:#fff;border-radius:16px;box-shadow:0 4px 24px rgba(0,0,0,.08);overflow:hidden;">' +
          '<div style="display:flex;border-bottom:2px solid #f0f0f0;">' +
          '<div style="flex:1;padding:18px 20px;display:flex;align-items:center;gap:10px;border-bottom:3px solid #28a745;margin-bottom:-2px;">' +
          '<div style="width:28px;height:28px;border-radius:50%;background:#28a745;color:#fff;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;">✓</div>' +
          '<span style="font-weight:700;font-size:14px;color:#28a745;">MACHINES</span></div>' +
          '<div style="flex:1;padding:18px 20px;display:flex;align-items:center;gap:10px;border-bottom:3px solid #28a745;margin-bottom:-2px;">' +
          '<div style="width:28px;height:28px;border-radius:50%;background:#28a745;color:#fff;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;">✓</div>' +
          '<span style="font-weight:700;font-size:14px;color:#28a745;">INFO</span></div></div>' +
          '<div style="padding:48px 32px;text-align:center;">' +
          '<div style="font-size:52px;margin-bottom:16px;">✅</div>' +
          '<h2 style="font-size:26px;font-weight:700;color:#212529;margin:0 0 12px;">Request Submitted!</h2>' +
          (isCustomQuote
            ? '<p style="color:#555;font-size:16px;margin:0 0 8px;">Thank you, <strong>' + formData.contactName + '</strong>. Your request has been received and sent to <strong>' + formData.email + '</strong>. A member of our team will review your configuration and follow up shortly with a custom quote.</p>'
            : '<p style="color:#555;font-size:16px;margin:0 0 8px;">Your estimate for <strong>' + formData.machines.length + ' machine' + (formData.machines.length !== 1 ? 's' : '') + '</strong> has been sent to <strong>' + formData.email + '</strong>.</p>') +
          '<p style="color:#999;font-size:13px;margin-top:20px;">A member of our team will follow up shortly.</p>' +
          '</div></div>';
      } else {
        throw new Error('Server error');
      }
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Submit & Get My Estimate';
      alert('There was an error submitting your order. Please try again or contact us directly.');
    }
  }

// ─── INIT ─────────────────────────────────────────────────────────────────
render();
});
